import { render, staticRenderFns } from "./HtmlText.vue?vue&type=template&id=5d9fabfa&scoped=true&"
import script from "./HtmlText.vue?vue&type=script&lang=js&"
export * from "./HtmlText.vue?vue&type=script&lang=js&"
import style0 from "./HtmlText.vue?vue&type=style&index=0&id=5d9fabfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9fabfa",
  null
  
)

export default component.exports